export const statsDataHero = [
  { label: "Data Points", value: 5, unit: "M", prefix: "+" },
  { label: "Market Models", value: 10, unit: "", prefix: "+" },
  { label: "Smarter Data", value: 100, unit: "x", prefix: "" },
];


export const slidesRealtimeAiPowered = [
  {
    image: "/images/dashboardOverview.png",
    alt: "Dashboard Overview",
  },
  {
    image: "/images/performanceOverview.png",
    alt: "Performance Overview",
  },
  {
    image: "/images/realtimeTechnicals.png",
    alt: "Realtime Technicals",
  },
];


export const productsData = [
  {
    title: "Dashboard",
    description:
      "Experience the oracle Real time aggregated market data feed and impact predictions. trading strategy, indicators and more.",
    image: "/images/productDashboard2.png",
    link: "https://dashboard.yoracle.ai",
    isComingSoon: false,
  },
  {
    title: "Telegram App",
    description:
      "Access the Oracle, Discover market movements and trends on Telegram.",
    image: "/images/productTgApp2.png",
    link: "https://t.me/y_tapp_bot/ytapp",
    isComingSoon: false,
  },
  {
    title: "Automated Trading",
    description:
      "Let the oracle trade for you. 24/7 with 0 emotions and pure data. Our Ai trading agent is actively managing its own vault on Hyperliquid.",
    image: "/images/productVault.png",
    link: "https://app.hyperliquid.xyz/vaults/0xed8878c9b4ed17d063a92ad8c454661fa1e2bac9",
    isComingSoon: false,
  },
  {
    title: "API Key",
    description:
      "Supercharge your application by accessing the most accurate, lowest-latency, and highest-resolution data.",
    image: "/images/productApi.png",
    link: "",
    isComingSoon: true,
  },
];


export const statsDataNetwork = [
  { label: "Holders", value: 6000, unit: "", prefix: "+" },
  { label: "Liquidity Lock", value: 2, unit: "years", prefix: "" },
  { label: "Liquidity Provision", value: 1.3, unit: "M", prefix: "+" },
];
